import { useQuery } from '@tanstack/react-query';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';
import { UISerializableOrder } from '@drift/common';
import { useWarnIfProviderMissing } from './useWarnIfProviderMissing';
import {
	accountTradingDataQueryKeys,
	GC_TIME_MS,
} from './accountTradingDataQueryKeys';
import { OrdersResult, OrdersByUserKey } from './utils/types';

const EMPTY_ORDERS: UISerializableOrder[] = [];

export function useOrdersByUserKey(userKey: string | undefined) {
	useWarnIfProviderMissing('useOrdersByUserKey');

	return useQuery<OrdersByUserKey, unknown, OrdersResult | undefined>({
		queryKey: accountTradingDataQueryKeys.orders(),
		queryFn: () => ({}),
		enabled: false,
		staleTime: Infinity,
		gcTime: GC_TIME_MS,
		select: (data) => (userKey ? data?.[userKey] : undefined),
	});
}

export function useCurrentAccountOrders(): UISerializableOrder[] {
	const userKey = useDriftAccountStore((s) => s.currentUserKey);
	const { data: result } = useOrdersByUserKey(userKey);
	return result?.openOrders ?? EMPTY_ORDERS;
}
